import { Location } from 'history';
import { getLogger } from 'mk2/logger';
import React from 'react';

declare const window: any;

interface OwnProps {
    app: string;
    location: Location;
}

type Props = OwnProps;

const logger = getLogger('TrackPageview');

function reportPageView(location: Location, app: string) {
    // Run on next event loop - so that we are not blocking react
    // TODO: consider requestIdleCallback?
    setTimeout(() => {
        const base = document.querySelector('base');
        const baseHref = base ? base.getAttribute('href') : '/';
        const url = `${baseHref.replace(/\/$/, '')}${location.pathname}${location.search}${location.hash}`;
        const eventData = {
            'event': 'track_pageview',
            'gtm.elementUrl': url,
            'gtm.url': url,
        };

        const loadFired = (document.readyState === 'complete');
        if (!loadFired) {
            // Document este nie je nacitany, pridaj event do bufferu
            //
            // Buffer sa vyprazdni potom cez tag manager ked nastane
            // Window Loaded (gtm.load) event
            // Tagy ktore sa spustaju na 'track_pageview' trigger tag
            // uz budu vediet spravny stav gdpr suhlasu, pretoze poradie
            // eventov bude:
            // - Consent Default
            //   defaultne nastavi suhlasy ako zamietnutie
            // - Container Loaded
            //   firne sa tesne po nacitani gtm.js
            // - Consent Update
            //   ces Privacy & Messages api sa nastavi skutocny stav suhlasov
            // - Window Loaded
            //   spustia vsetky tagy cakajuce na nacitanie stranky,
            //   vratane snippetu, ktory cez window.dataLayer.push({...});
            //   prida nabuffrovane track_pageview event, ktore sa vykonaju
            //   v dalsom event loope
            window.mkQueuedPageviews = window.mkQueuedPageviews || [];
            window.mkQueuedPageviews.push(eventData);
        } else {
            // Document uz je nacitany, posli event hned
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push(eventData);
            } else {
                logger.error('no GTM datalayer');
            }
        }
    });
}

export class TrackPageview extends React.Component<Props> {

    public componentDidMount() {
        reportPageView(this.props.location, this.props.app);
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.location !== prevProps.location) {
            reportPageView(this.props.location, this.props.app);
        }
    }

    public render() {
        const { children } = this.props;
        return children ? React.Children.only(children) : null;
    }

}
